import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import messages from '../messages';
import style from './style.module.less';
import FacebookImage from './images/facebook.png';
import InstagramImage from './images/instagram.png';
import TwitterImage from './images/twitter.png';

const socialNetwork = {
  facebook: {
    name: messages.facebookProfile,
    url: 'http://facebook.com/',
    imgSrc: FacebookImage,
    altText: 'Facebook',
  },
  instagram: {
    name: messages.instagramProfile,
    url: 'http://instagram.com/',
    imgSrc: InstagramImage,
    altText: 'Instagram',
  },
  twitter: {
    name: messages.twitterProfile,
    url: 'http://twitter.com/',
    imgSrc: TwitterImage,
    altText: 'Twitter',
  },
};

const SocialInput = ({ value = '', onChange, network }) => {
  const intl = useIntl();
  const networkData = socialNetwork[network];
  return (
    <div className={style['social-input-container']}>
      <div className={style['social-info']}>
        <img alt={networkData.altText} src={networkData.imgSrc} />
        {networkData.url}
      </div>
      <input onChange={(ev) => onChange(ev.target.value)} placeholder={intl.formatMessage(networkData.name)} value={value} />
    </div>
  );
};

SocialInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  network: PropTypes.oneOf(Object.keys(socialNetwork)).isRequired,
};

export default SocialInput;
